import React, { useState } from 'react';
import Layout from 'layouts/manager/Layout';
import Pagination from 'components/Pagination';

// ダミーデータ
const updateHistoryData = [
  {
    date: '2025-06-25',
    day: '水',
    time: '14:32',
    user: '山田太郎',
    action: '店舗情報',
    type: '更新',
  },
  {
    date: '2025-06-24',
    day: '火',
    time: '09:15',
    user: '佐藤花子',
    action: '契約情報',
    type: '登録',
  },
  {
    date: '2025-06-23',
    day: '月',
    time: '18:05',
    user: '田中一郎',
    action: '請求情報',
    type: '削除',
  },
];

const Search: React.FC = () => {
  const [open, setOpen] = useState(true);
  const [search, setSearch] = useState({
    date: '',
    user: '',
  });
  // ページネーション用
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;
  const filtered = updateHistoryData.filter(row => {
    return (
      (!search.date || row.date === search.date) &&
      (!search.user || row.user.includes(search.user))
    );
  });
  const totalRows = filtered.length;
  const totalPages = Math.max(1, Math.ceil(totalRows / rowsPerPage));
  const pagedData = filtered.slice((page - 1) * rowsPerPage, page * rowsPerPage);

  return (
    <Layout>
      <div className="mx-auto">
        <h1 className="mb-3 text-lg font-bold text-gray-800">更新履歴</h1>
        {/* 検索項目 */}
        <div className="mb-6">
          <button
            className="flex items-center w-full px-4 py-2 rounded-t-lg"
            style={{ backgroundColor: '#f7fafd' }}
            onClick={() => setOpen((v) => !v)}
            type="button"
          >
            <span
              className="mr-2 text-lg transition-transform"
              style={{ color: '#002c6a', transform: open ? 'rotate(0deg)' : 'rotate(-90deg)' }}
            >
              ▼
            </span>
            <span className="flex-1 text-base font-bold text-left" style={{ color: '#002c6a' }}>
              検索
            </span>
          </button>
          {open && (
            <div className="p-4 bg-white border rounded-b-lg shadow">
              <form className="grid grid-cols-1 gap-4 md:grid-cols-3">
                <div>
                  <label className="block mb-1 text-sm text-gray-600">日時</label>
                  <input type="date" className="w-full px-2 py-1 border rounded" value={search.date} onChange={e => setSearch({ ...search, date: e.target.value })} />
                </div>
                <div>
                  <label className="block mb-1 text-sm text-gray-600">ユーザー</label>
                  <input type="text" className="w-full px-2 py-1 border rounded" placeholder="ユーザー名を入力" value={search.user} onChange={e => setSearch({ ...search, user: e.target.value })} />
                </div>
                <div className="flex justify-start mt-2 md:col-span-3">
                  <button
                    type="submit"
                    className="px-3 py-1 text-sm transition rounded"
                    style={{ color: '#ffffff', background: '#002c6a' }}
                    onClick={e => { e.preventDefault(); setPage(1); }}
                  >
                    検索
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
        {/* 一覧リスト */}
        <div className="p-4 bg-white border rounded shadow">
          <ul className="divide-y divide-gray-200">
            {pagedData.length === 0 && (
              <li className="py-4 text-center text-gray-400">該当する履歴がありません</li>
            )}
            {pagedData.map((row, idx) => {
              const detailUrl = `/manager/update-history/diff/${row.date}-${row.user}-${idx}`;
              return (
                <li key={idx} className="flex flex-col gap-2 py-4 md:flex-row md:items-center md:gap-6">
                  <span className="w-32 font-mono text-sm text-gray-700">{row.date}（{row.day}）</span>
                  <span className="w-20 text-sm text-gray-500">{row.time}</span>
                  <span className="flex-1 text-sm text-gray-800">
                    {row.user}さんが{' '}
                    <a href={detailUrl} className="text-blue-700 underline hover:text-blue-900">{row.action}</a>
                    {` を${row.type}しました。`}
                  </span>
                </li>
              );
            })}
          </ul>
          {/* ページネーション */}
          <Pagination page={page} totalPages={totalPages} onPageChange={setPage} />
        </div>
      </div>
    </Layout>
  );
};

export default Search;
